// extracted by mini-css-extract-plugin
var _1 = "copy--nFhPrXT";
var _2 = "logo--y8Oi_Dq";
var _3 = "panel--k76ooBF";
var _4 = "panel__title--GzmwiHX";
export { _1 as "copy", _2 as "logo", _3 as "panel", _4 as "panelTitle" }
